import { makeStyles } from 'tss-react/mui';

const name = 'ChainInfo';

export const useChainInfoStyles = makeStyles({ name })(theme => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(3),

    width: '100%',
    padding: theme.spacing(4, 5),

    border: `1px solid ${theme.palette.divider}`,

    borderRadius: theme.shape.borderRadiusMd,
  },
  info: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
  },
}));
